export const isValueStringOrNumber = (value: unknown): value is string | number =>
  typeof value === 'string' || typeof value === 'number';
